import { render, staticRenderFns } from "./OptometristYuFuKuanIn.vue?vue&type=template&id=1fdae61d&scoped=true&"
import script from "./OptometristYuFuKuanIn.vue?vue&type=script&lang=js&"
export * from "./OptometristYuFuKuanIn.vue?vue&type=script&lang=js&"
import style0 from "./OptometristYuFuKuanIn.vue?vue&type=style&index=0&id=1fdae61d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdae61d",
  null
  
)

export default component.exports